import { jsx as _jsx } from "react/jsx-runtime";
import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UpgradeConfigContent from './UpgradeConfigContent';
import { mainBreakpoints } from '../../common/ProductInfoContainer';
const HeroBG = styled.div.withConfig({
  displayName: "UpgradeModalHeroBanner__HeroBG",
  componentId: "mnscp1-0"
})(["width:100%;z-index:-1;background-color:", ";"], GYPSUM);
const ContentContainer = styled.div.withConfig({
  displayName: "UpgradeModalHeroBanner__ContentContainer",
  componentId: "mnscp1-1"
})(["", " padding-bottom:42px;margin-bottom:32px;"], mainBreakpoints);

const UpgradeModalHeroBanner = ({
  upgradeConfig
}) => {
  return /*#__PURE__*/_jsx(HeroBG, {
    children: /*#__PURE__*/_jsx(ContentContainer, {
      className: "m-x-auto",
      children: /*#__PURE__*/_jsx(UpgradeConfigContent, {
        upgradeConfig: upgradeConfig
      })
    })
  });
};

export default UpgradeModalHeroBanner;